import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { PdfViewerDialog } from 'src/app/compliance/shared/pdf-viewer-dialog.component';
import { openDocumentPage } from 'src/app/compliance/store/actions/document-batch-details.actions';
import {
    loadCandidateDocumentByDocumentIdFailure,
    loadCandidateDocumentByDocumentIdSuccess,
    loadDocumentAsPdf,
    loadDocumentAsPdfFailure,
    loadDocumentAsPdfSuccess,
    selectedDocumentId
} from 'src/app/compliance/store/actions/document-reviewer.actions';
import { DocumentService } from 'src/app/core/document.service';
import { DocumentUploadToolClient } from '../../api/document-upload-tool-client.service';
import { DocumentUploadToolDetailDto } from '../../api/models/document-upload-tool-detail-dto.model';

@Injectable()
export class DocumentEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly documentUploadToolClient: DocumentUploadToolClient,
        private readonly _documentService: DocumentService,
        private readonly _matDialog: MatDialog
    ) {}

    getCandidateDocumentByDocumentId$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(selectedDocumentId),
            switchMap((action) => {
                return this.documentUploadToolClient.getCandidateDocument(action.documentId).pipe(
                    map((result: DocumentUploadToolDetailDto) => loadCandidateDocumentByDocumentIdSuccess({ candidateDocument: result })),
                    catchError((error: unknown) => of(loadCandidateDocumentByDocumentIdFailure({ error })))
                );
            })
        );
    });

    getDocumentAsPdf$ = createEffect(() => {
        return this._actions$.pipe(
            ofType(loadDocumentAsPdf),
            switchMap((action) =>
                this._documentService.getDocumentAsPdf(action.documentId).pipe(
                    map((result) => loadDocumentAsPdfSuccess({ document: result })),
                    catchError((error: unknown) => of(loadDocumentAsPdfFailure({ error })))
                )
            )
        );
    });

    openDocumentPage$ = createEffect(
        () => {
            return this._actions$.pipe(
                ofType(openDocumentPage),
                map((action) => {
                    this._documentService
                        .getDocumentAsPdf(action.docId)
                        .pipe(take(1))
                        .subscribe((document) => {
                            this._matDialog.closeAll();
                            this._matDialog.open(PdfViewerDialog, {
                                data: {
                                    document$: of(document),
                                    pageNumber: action.pageNum
                                },
                                panelClass: ['nova__dialog', 'nova__dialog--lg']
                            });
                        });
                })
            );
        },
        { dispatch: false }
    );
}
